// collection collection tab section mobile drawer js code start 
document.addEventListener('DOMContentLoaded', function() {
  const body = document.body;
  const tabSection = document.querySelector('.custom-collections-tab-section');
  const filterPanel = document.querySelector('.facets__panel.has-mob-drawer');

  function initMobileDrawer() {
    document.addEventListener('click', mobileClickHandler);
  }

  function destroyMobileDrawer() {
    document.removeEventListener('click', mobileClickHandler);
    // Clean up any active states if resizing to desktop
    if (tabSection) tabSection.classList.remove('active');
    body.classList.remove('has-custom-drawer');
  }

  function mobileClickHandler(e) {
    const sortBtn = e.target.closest('.custom-sort-collection');
    const closeBtn = e.target.closest('.custom-collections-tab-popup-close');
    const filterLabel = e.target.closest('.has-mob-drawer-label');
    const filterCloseBtn = e.target.closest('.custom-collections-filter-popup-close');
    const filterOptLabel = e.target.closest('.custom-collections-filter-opt label');

    if (sortBtn && tabSection) {
      e.preventDefault();
      tabSection.classList.add('active');
      body.classList.add('has-custom-drawer');
      e.stopPropagation();
    }

    if (closeBtn && tabSection) {
      e.preventDefault();
      tabSection.classList.remove('active');
      body.classList.remove('has-custom-drawer');
    }

    if (filterLabel && filterPanel) {
      filterPanel.click();
      body.classList.add('has-custom-drawer');
    }

    if (filterCloseBtn && filterPanel) {
      e.preventDefault();
      filterPanel.click();
      body.classList.remove('has-custom-drawer');
    }
    if (filterOptLabel) {
        body.classList.remove('has-custom-drawer');
    }

    const clickedInsideTab = e.target.closest('.custom-collections-tab-section');
    const clickedInsideFilter = e.target.closest('.facets__panel.has-mob-drawer');
    const clickedTrigger = sortBtn || filterLabel;

    if (!clickedInsideTab && !clickedInsideFilter && !clickedTrigger) {
      if (tabSection && tabSection.classList.contains('active')) {
        tabSection.classList.remove('active');
      }
      if (filterPanel && filterPanel.classList.contains('active')) {
        filterPanel.click();
      }
      body.classList.remove('has-custom-drawer');
    }
  }

  function checkScreenSize() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      initMobileDrawer();
    } else {
      destroyMobileDrawer();
    }
  }

  checkScreenSize();

  window.addEventListener('resize', checkScreenSize);
});

// collection collection tab section mobile drawer js code end


// js code for article page sticky navigation start 

if (window.innerWidth > 767) {
  var toolbar = document.querySelector('.article-custom-sticky-navigation');
  var headerComponent = document.getElementById('header-component');

  if (toolbar) {
    var setToolbarPosition = function () {
      var header_height = headerComponent ? headerComponent.offsetHeight : 0; // height check on each call
      toolbar.style.top = header_height - 2 + 'px';
    };

    var toggleToolbarClass = function () {
      var scrollTop = window.scrollY || window.pageYOffset;
      var header_height = headerComponent ? headerComponent.offsetHeight : 0;

      if (scrollTop > header_height) {
        toolbar.classList.add('active');
      } else {
        toolbar.classList.remove('active');
      }
    };

    window.addEventListener('scroll', toggleToolbarClass);

    window.addEventListener('resize', function () {
      setToolbarPosition();
      toggleToolbarClass();
    });

    setToolbarPosition();
    toggleToolbarClass();
  }
}



// js code for article page sticky navigation end

// Location redirect code start
// Settings come from Theme settings → Location Redirect, output by snippets/scripts.liquid (#ip-redirect-settings)

var ipRedirectSettings = document.getElementById('ip-redirect-settings');
if (typeof IPRedirect !== 'undefined' && ipRedirectSettings) {
  try {
    IPRedirect.init(JSON.parse(ipRedirectSettings.textContent));
    IPRedirect.run();
  } catch (e) {
    console.error('Location redirect skipped:', e);
  }
}

// Location redirect code end